
/**
 * This is the entry file for the frontend application.
 */

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

/** --------------------------------
 * Cookiebar handler
 * -------------------------------- */

import CookiebarHandler from '../Handlers/CookiebarHandler';
const cookiebarHandler = new CookiebarHandler();

/** --------------------------------
 * Styles
 * -------------------------------- */

import '../../Features/Layouts/Root/Styles/Root.scss';

/** --------------------------------
 * Components
 * -------------------------------- */

// Import all Components
import { components } from './_components.js';

// Instatiate Components
components.map(Component => ( new Component() ))

/** --------------------------------
 * Helpers
 * -------------------------------- */

// import registerFauxClickAreas from '../Handlers/RegisterFauxClickAreas';
// registerFauxClickAreas();

// import '../Handlers/RegisterServiceWorker';
